import React from 'react';
import { Row, Col, Card, Button, Typography, notification } from 'antd';
import { AndroidFilled,AppleFilled, DownloadOutlined, WindowsFilled } from '@ant-design/icons';
import './DownloadPage.css';

const { Title, Text } = Typography;

const DownloadPage: React.FC = () => {
  const handleAndroidDownload = () => {
    window.open("https://train.miaoshili.com/download/app-release.apk", "_blank");
  };

  const handleWindowsDownload = () => {
    window.open("https://train.miaoshili.com/download/nice-vision-install.exe", "_blank");
  };

  const handleIOSDownload = () => {
    // notification.info({
    //   message: '敬请期待',
    // });
    window.open("https://apps.apple.com/cn/app/id6752773415", "_blank");
  };

  return (
    <div className="download-page">
        <div className="download-page-bg">
            {/* 主要内容区域 */}
            <div className="main-content">
                <div className="logo-section">
                    <div className="logo-image"><img src="./msl_app_logo.webp" width={"100%"}/> </div>
                    <Title level={2} className="app-title">妙视力</Title>
                </div>

                <Text className="download-text">立即下载</Text>

                <Row gutter={[30, 30]} justify="center">
                    <Col xs={24} sm={12} md={8}>
                        {/* Android版本 */}
                        <Card className="download-card android-card" bordered={false}>
                            <div className="card-content">
                                <div className="card-icon">
                                    <div className="icon-background android-icon">
                                        <AndroidFilled className="card-icon-inner" />
                                    </div>
                                </div>
                                <Title level={3} className="card-title">Android版本</Title>
                                <Text className="card-description">支持所有Android设备</Text>
                                <Text className="version-text">版本1.0.0</Text>
                                <Button type="primary" className="download-button" icon={<DownloadOutlined />} onClick={handleAndroidDownload}>
                                    下载Android版
                                </Button>
                            </div>
                        </Card>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        {/* Windows版本 */}
                        <Card className="download-card windows-card" bordered={false}>
                            <div className="card-content">
                                <div className="card-icon">
                                    <div className="icon-background windows-icon">
                                        <WindowsFilled className="card-icon-inner" />
                                    </div>
                                </div>
                                <Title level={3} className="card-title">Windows版本</Title>
                                <Text className="card-description">支持Win10及以上设备</Text>
                                <Text className="version-text">版本1.0.0</Text>
                                <Button type="primary" className="download-button" icon={<DownloadOutlined />} onClick={handleWindowsDownload}>
                                    Windows版
                                </Button>
                            </div>
                        </Card>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        {/* iOS版本 */}
                        <Card className="download-card ios-card" bordered={false}>
                            <div className="card-content">
                                <div className="card-icon">
                                    <div className="icon-background ios-icon">
                                        <AppleFilled className="card-icon-inner" /> {/* 临时使用Android图标，实际应使用iOS图标 */}
                                    </div>
                                </div>
                                <Title level={3} className="card-title">iOS版本</Title>
                                <Text className="card-description">支持所有iOS设备</Text>
                                <Text className="version-text">版本1.0.0</Text>
                                <Button type="primary" className="download-button" icon={<DownloadOutlined />} onClick={handleIOSDownload}>
                                    下载iOS版
                                </Button>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  );
};

export default DownloadPage;